import { readableColor } from 'polished';
import { RepresentationData } from '@ardoq/data-model';
import { colors } from '@ardoq/design-tokens';
import { HtmlCanvasVisual, IRenderContext } from '@ardoq/yfiles';
import {
  MODERNIZED_BLOCK_DIAGRAM_FONT as FONT,
  MODERNIZED_BLOCK_DIAGRAM_LINE_HEIGHT as LINE_HEIGHT,
} from '@ardoq/graph-labeling';
import {
  MODERNIZED_BLOCK_DIAGRAM_EXPANDER_SIZE as EXPANDER_SIZE,
  MODERNIZED_BLOCK_DIAGRAM_GROUP_HEADER_ICON_HEIGHT as HEADER_ICON_HEIGHT,
} from '../consts';
import { drawImage } from 'tabview/canvasRendering/drawImage';
import { paintIcon } from 'tabview/canvasRendering/paintIcon';

class GroupLabelVisual extends HtmlCanvasVisual {
  constructor(
    private x: number,
    private y: number,
    private wrappedMainLabel: string[],
    private isTransparentized: boolean,
    private stripeColor: string | null,
    private representationData: RepresentationData | null
  ) {
    super();
  }
  override render(
    renderContext: IRenderContext,
    ctx: CanvasRenderingContext2D
  ): void {
    const globalAlpha = ctx.globalAlpha;
    if (this.isTransparentized) {
      ctx.globalAlpha = 0.32;
    }
    const textColor = this.stripeColor
      ? readableColor(this.stripeColor, colors.grey950, colors.white950)
      : colors.black950;

    if (this.representationData) {
      const { isImage, value, icon } = this.representationData;
      const representationX = this.x + HEADER_ICON_HEIGHT / 2;
      const representationY = this.y + HEADER_ICON_HEIGHT / 2;
      if (isImage && value) {
        drawImage(
          ctx,
          value,
          representationX,
          representationY,
          HEADER_ICON_HEIGHT
        );
      } else if (icon) {
        paintIcon(
          ctx,
          representationX,
          representationY,
          HEADER_ICON_HEIGHT,
          textColor,
          icon
        );
      }
    }

    ctx.font = FONT;
    const labelX =
      this.x + (this.representationData ? HEADER_ICON_HEIGHT + 2 : 0);
    const firstLineY =
      this.y +
      (this.wrappedMainLabel.length > 1 ? LINE_HEIGHT / 2 : EXPANDER_SIZE / 2);
    ctx.fillStyle = textColor;
    const textBaseline = ctx.textBaseline;
    const textAlign = ctx.textAlign;
    ctx.textAlign = 'start';
    ctx.textBaseline = 'middle';
    this.wrappedMainLabel.forEach((line, lineIndex) => {
      const lineY = firstLineY + LINE_HEIGHT * lineIndex;
      ctx.fillText(line, labelX, lineY);
    });
    ctx.textBaseline = textBaseline;
    ctx.textAlign = textAlign;
    ctx.globalAlpha = globalAlpha;
  }
}
export { GroupLabelVisual };
